<template>
  <div
    class="modal modal-widget modal-search fade"
    id="contactModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              contactez-nous
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <validation-provider
                        name="lastname"
                        rules="required"
                        v-slot="{ errors }"
                        mode="lazy"
                      >
                        <label class="text-uppercase" for="contact-lastname"
                          >votre nom<sup class="text-danger">*</sup>
                        </label>
                        <input
                          v-model="form.name"
                          type="text"
                          class="form-control"
                          id="contact-lastname"
                          placeholder="Votre nom"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="form-group">
                      <validation-provider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                        mode="lazy"
                      >
                        <label class="text-uppercase" for="contact-email"
                          >Adress E-mail <sup class="text-danger">*</sup></label
                        >
                        <input
                          v-model="form.email"
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors.length }"
                          id="contact-email"
                          placeholder="Adress E-mail"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>

                    <div class="form-group">
                      <validation-provider
                        name="companyName"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label class="text-uppercase" for="contact-company-name"
                          >{{ $t('form.companyName') }}
                          <sup class="text-danger">*</sup></label
                        >
                        <input
                          v-model="form.companyName"
                          type="text"
                          class="form-control"
                          id="contact-company-name"
                          :class="{ 'is-invalid': errors.length }"
                          :placeholder="$t('form.companyName')"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <validation-provider
                        name="message"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label class="text-uppercase" for="contact-message"
                          >message<sup class="text-danger">*</sup>
                        </label>
                        <textarea
                          v-model="form.message"
                          type="text"
                          class="form-control h-100"
                          id="contact-message"
                          placeholder="Votre nom"
                          rows="13"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="custom-control custom-checkbox mt-3">
                      <validation-provider
                        name="accepted"
                        :rules="{ required: { allowFalse: false } }"
                        v-slot="{ errors }"
                      >
                        <input
                          name="accepted"
                          v-model="form.accepted"
                          type="checkbox"
                          class="custom-control-input"
                          :class="{ 'is-invalid': errors.length }"
                          id="contact-accepted"
                        />
                        <label
                          class="custom-control-label text-uppercase"
                          for="contact-accepted"
                        >
                          {{ $t('acceptLabel') }}
                          <sup class="text-danger">*</sup></label
                        >
                        <span
                          class="text-danger small"
                          v-show="errors.length"
                          >{{ $t('errors.contactAccept') }}</span
                        >
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </form>
              <div class="modal-footer d-flex justify-content-between pt-3">
                <div class="w-50">
                  <div
                    v-if="monitor.visible"
                    class="px-1 text-center"
                    :class="monitor.type"
                  >
                    {{ monitor.message }}
                  </div>
                </div>
                <div>
                  <button
                    @click="store"
                    class="btn btn-primary btn-icon-right"
                    :class="{ disabled: invalid }"
                    :disabled="invalid || isSaving"
                  >
                    {{ $t('buttons.send') }}
                    <div class="icon icon-arrow-right_white"></div>
                  </button>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactModal',
  data() {
    return {
      form: {},
      isSaving: false,
      monitor: {
        visible: false,
        message: '',
        type: 'text-danger',
      },
    }
  },
  methods: {
    store() {
      let data = {
        action: 'send_quote_contact',
        name: this.form.name,
        email: this.form.email,
        company: this.form.companyName,
        message: this.form.message,
        accept: this.form.accept,
      }
      this.isSaving = true
      this.$store
        .dispatch('setContactData', data)
        .then(() => {
          this.monitor.type = 'text-success'
          this.monitor.message = this.$t('savedInformations')
          this.monitor.visible = true
          setTimeout(() => {
            this.monitor.visible = false
            this.monitor.type = ''
            this.monitor.message = ''
            this.reset()
            this.closeModal()
          }, 3000)
        })
        .finally(() => {
          this.isSaving = false
        })
    },

    closeModal() {
      setTimeout(() => {
        $('#contactModal').modal('hide')
      }, 500)
    },
    reset() {
      this.form = {}
      this.$refs.form.reset()
    },
  },
}
</script>

<style></style>
